/**
 * ColourHelper::hexToRgb()
 *
 * @param hex
 * @returns {{r: number, b: number, g: number}|number}
 */
export const hexToRgb = (hex) => {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

    return result ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16)
    } : 0;
}

/**
 * ColourHelper::contrastTextColour()
 *
 * @param backgroundColour
 * @returns {string}
 */
export const contrastTextColour = (backgroundColour) => {
    const rgb = hexToRgb(backgroundColour);

    const brightness = Math.round(((parseInt(rgb.r) * 299) + (parseInt(rgb.g) * 587) + (parseInt(rgb.b) * 114)) / 1000);

    return (brightness > 125) ? '#3d3d3d' : '#ffffff';
}
